/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tld_Pricing_Priced_AllInputs */

const id_tld_pricing_priced_all = /** @type {(inputs: Tld_Pricing_Priced_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Semua status harga`)
};

const en_tld_pricing_priced_all = /** @type {(inputs: Tld_Pricing_Priced_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priced or not`)
};

/**
* | output |
* | --- |
* | "Priced or not" |
*
* @param {Tld_Pricing_Priced_AllInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const tld_pricing_priced_all = /** @type {((inputs?: Tld_Pricing_Priced_AllInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tld_Pricing_Priced_AllInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tld_pricing_priced_all(inputs)
	return id_tld_pricing_priced_all(inputs)
});